import { TrendingUp } from "lucide-react";

const CHIP_STYLES = [
  "border-flame/30 bg-flame/10 text-flame",
  "border-[#FACC15]/50 bg-[#FEF9C3] text-[#713F12]",
  "border-[#14B8A6]/40 bg-[#CCFBF1] text-[#115E59]",
  "border-[#EF4444]/40 bg-[#FEE2E2] text-[#991B1B]",
];

export default function CaseStatChips({ items, testPrefix, className = "" }) {
  if (!items || !items.length) return null;
  return (
    <div className={`flex flex-wrap gap-3 ${className}`}>
      {items.map((s, si) => (
        <div
          key={s.small}
          data-testid={`${testPrefix}-${si}`}
          className={`flex flex-1 items-center gap-3 rounded-2xl border px-4 py-3 ${CHIP_STYLES[si % 4]}`}
        >
          <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-white/80">
            <TrendingUp className="h-4 w-4" />
          </span>
          <span>
            <span className="block font-display text-3xl font-extrabold leading-none">
              {s.big}
            </span>
            <span className="mt-1 block font-mono text-[13px] uppercase tracking-[0.14em]">
              {s.small}
            </span>
          </span>
        </div>
      ))}
    </div>
  );
}
